export enum LocalStorageEnum {
  DARKMODE = 'darkMode',
  THEME = 'theme',
  LEFT_ALIGN = 'leftAlign',
  FIRST_RUN_DONE = 'firstRunDone',
  LEFT_DRAWER_MINI_STATE = 'leftDrawerMiniState',
  ZOOM_ON_MOBILE = 'zoomOnMobile',
  ZOOM_ON_DESKTOP = 'zoomOnDesktop',
  RELOAD_METHOD = 'RELOAD_METHOD'
}
